export const help_zh = {
    help:{     
        said:"说点什么...",
        publish:"发表",
        building:"楼",
        reply:"回复",
        determine:"确定",
        cancel:"取消", 
        num:"编号",
        userDate:"日期",
        userName:"用户名",
        msgPage:"留言页面",
        userMsg:"留言内容",
        operation:"操作",
        inputContent:"输入内容",
        submitReply:"提交回复",
        responDate:"回复时间",
        responser:"回复人",
        respon:"回复内容",
        submissionTime:"提交时间",
        problem:"问题分类",
        problemTitle:"问题标题",
        dealWith:"处理状态",
        details:"详情",
        orderDetails:"工单详情",
        orderNumber:"工单编号",
        submitName:"提交用户名",
        submitContent:"提交内容",
        download:"下载附件",
        uploaded:"文件上传中...",
        sumWarning:"请确认数据填写完整在提交！",
        resubmit:"请确认填写提交内容！",
        recall:"撤回",
        toAudit:"已经是待审核状态，不能重复提交！",
        AuditContent:"审核内容：",
        account:"账户",
        time:"时间",
        Continue:"继续提交",
        SubmitToday:"今日提交工单数",
        processed:"已处理工单数",
        unprocessed:"未处理工单数",
        beReviewed:"待审核工单数",
        reviewed:"已审核工单数",
        chart:"工单每日历史图表",
        timeout:"超时工单列表",
        beProcessed:"待处理工单列表",
        processedTable:"已处理工单列表",
        beReviewedTable:"待审核工单列表",
        reviewedTable:"已审核工单列表",
        withdrawTable:"已撤回工单列表",
        processing:"工单处理",
        requestReview:"请求审核",
        AuditOpinion:"审核意见",
        audit:"审核",
        AuditUser:"审核用户",
        AuditTime:"审核时间",
        unreadWork:"未读工单汇总",
        submittedWork:"已提交工单列表",
        ReplyUnread:"已回复未读工单列表",
        closedTable:"已关闭工单列表",
        sameName:"不能上传相同名字的文件!",
        fileType:"不支持的文件类型",
        fileSize:"文件大小不能超过",
        fileNum:"超出最大上传文件数量的限制！",
        solve:"该工单问题已解决?",
        end:"结束工单",
        problemTitle1:"请确认填写标题内容！",
        problem2:"请确认选择问题种类！",
        describe:"请确认填写描述内容！",
        historyTable:"工单提交历史列表",






    }
}
export const help_en = {
    help:{
        backstage:"Message board backstage",
        messageBoard:"Message board",
        message:"I'd like to leave a message.",
        said:"Say something...",
        publish:"publish",
        building:"layer",
        determine:"determine",
        cancel:"cancel",
        help:"This page is helpful to you?",
        said1:"Let me say something...",
        reply:"reply",
        todayMessage:"Number of messages today",
        processedMessage:"Number of messages processed",
        unprocessedMessage:"Number of unprocessed messages",
        historyChart:"Comment daily history chart",
        unprocessedTabel:"The message list is not processed",
        num:"number",
        userDate:"date",
        userName:"User name",
        msgPage:"Message page",
        userMsg:"Message content",
        operation:"operation",
        inputContent:"Input content",
        submitReply:"Submit a reply",
        processedTabel:"The message list has been processed",
        responDate:"Recovery time",
        responser:"responder",
        respon:"Reply content",
        unread:"Unread message label",
        unreadTabel:"List of unread messages",
        submissionTime:"Submission time",
        submittedTabel:"A list of comments has been submitted",
        problem:"Problem classification",
        problemTitle:"Question heading",
        dealWith:"Processing state",
        details:"details",
        orderDetails:"Work order details",
        orderNumber:"Work order number",
        submitName:"Submit user name",
        submitContent:"Submit content",
        download:"Download attachment",
        uploaded:"The file is uploaded...",
        sumWarning:"Please confirm that the data is complete before submission!",
        resubmit:"Please confirm to fill in the submission content!",
        recall:"withdraw",
        toAudit:"It is in the state to be reviewed and cannot be submitted again!",
        AuditContent:"Content of review:",
        account:"account",
        time:"time",
        Continue:"Continue to submit",
        SubmitToday:"The number of jobs submitted today",
        processed:"The number of processed jobs",
        unprocessed:"Unprocessed number of workers",
        beReviewed:"Number of workers to be audited",
        reviewed:"The number of approved workers",
        chart:"Daily history chart of work order",
        timeout:"Overtime work order list",
        beProcessed:"Waiting list of science and technology",
        processedTable:"List of processed work orders",
        beReviewedTable:"List of work order to be reviewed",
        reviewedTable:"Audited work order list",
        withdrawTable:"Retracted work order list",
        processing:"Work order processing",
        requestReview:"Request review",
        AuditOpinion:"Audit opinion",
        audit:"audit",
        AuditUser:"Audit user",
        AuditTime:"Audit time",
        unreadWork:"Summary of unread work orders",
        submittedWork:"Work order list has been submitted",
        ReplyUnread:"The list of unread work orders has been returned",
        closedTable:"Closed order list",
        sameName:"You cannot upload files with the same name!",
        fileType:"Unsupported file type!",
        fileSize:"The file size cannot exceed",
        fileNum:"The maximum number of uploaded files is exceeded!",
        solve:"The issue with this work order has been resolved?",
        end:"End Work Order",
        problemTitle1:"Please confirm to fill in the title content!",
        problem2:"Please confirm selecting the type of problem!",
        describe:"Please confirm to fill in the description content!",
        historyTable:"Historical work orders",
    }
}